import { useNavigate } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import SectionLayout from 'layouts/SectionLayout';
import MainLayout from 'layouts/MainLayout';

export interface LoanEstimateResponseTypes {
  approvedLoanAmount: number | string;
  durationInMonths: number;
  isApproved: boolean;
  message: string;
  monthlyRepayment: string | number;
}
const LoanCalculator = () => {
  const loanTypes = [
    {
      title: 'School Fees',
      text: 'Estimate loan for school fees',
      path: '/loan-calculator/school',
      iconSrc: '/icon/School.svg',
      bg: '#bg-[424E9B4D]',
    },
    {
      title: 'Transport Credit',
      text: 'Estimate loan for transportation ',
      path: '/loan-calculator/transport',
      iconSrc: '/icon/Car.svg',
      bg: 'bg-[#F055424D]',
    },
    {
      title: 'House Rent',
      text: 'Estimate loan for house rent ',
      path: '/loan-calculator/rent',
      bg: 'bg-[#0066FF4D]',

      iconSrc: '/icon/House.svg',
    },
  ];
  const navigate = useNavigate();
  return (
    <MainLayout>
      <SectionLayout>
        <section className="my-10 w-full max-w-2xl mx-auto">
          <article>
            <h2 className="text-[#212121] text-lg md:text-xl font-bold">
              Loan Calculator
            </h2>
            <p className="text-[#616161] mt-2 md:text-lg leading-[140%]">
              Calculate how much we are likely to give you as a loan.
            </p>
          </article>

          <div className="mt-4 text-center text-white rounded-lg bg-gradient-to-br from-[#876DFF] to-[#A591FF] flex flex-col justify-center gap-4 p-6">
            <p>Get access in 48 hours to a loan up to </p>
            <p className="text-2xl font-bold">₦500,000.00</p>
            <span className="text-[#faec6d] text-sm italic">
              Within 48 hours of receiving your valid documents.
            </span>
          </div>
          <section className="mt-6 flex justify-center items-center gap-6 flex-wrap">
            {loanTypes.map(({ title, path, bg, iconSrc, text }, idx) => {
              return (
                <div
                  key={idx}
                  className=" rounded-lg w-full min-h-[160px] p-6 shadow  bg-white  md:max-w-[200px] text-center cursor-pointer"
                  onClick={() => navigate(path)}
                >
                  <div className="flex justify-end">
                    <ChevronRight size={24} color="#EFA005" />
                  </div>
                  <div
                    className={`${bg} size-[60px] mx-auto flex items-center justify-center border rounded-full`}
                  >
                    <img
                      src={iconSrc}
                      className=""
                      alt={title}
                      width={32}
                      height={32}
                    />
                  </div>
                  <h4 className="mb-2 text-[#212121B2] font-bold leading-[160%] ">
                    {title}
                  </h4>
                  <p className="text-[#616161] leading-[140%] text-sm ">
                    {text}
                  </p>
                </div>
              );
            })}
          </section>
        </section>
      </SectionLayout>
    </MainLayout>
  );
};

export default LoanCalculator;
